<template>
  <collapsable
    :collapsed="collapsed"
    :title="$t('entities.roles.title', {name: entity.name})"
  >
    <span slot="beforeCollapse" class="d-flex align-items-center">
      <Searchable
        :querySearch.sync="querySearch"
        :placeholder="this.$t('entities.roles.search_by_user')"
      />
    </span>

    <div v-if="isFetchingServer">
      <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-else-if="userHasRoles">
      <ViewEntityPermissionsByUser
        v-if="userHasRoles"
        :roles="entityRoles"
        :query="querySearch"
        :limitItems="limitItems !== null ? limitItems : limitItemsByScreenSize"
      />
    </div>
    <div v-show="showLoadingIndicator">
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
  </collapsable>
</template>
<script>
import { mapGetters } from 'vuex'
import { RoleService } from '@/api/AuthService'
import Searchable from '@/components/common/Searchable'
import Collapsable from '@/components/common/Collapsable'
import LoadingAnimation from '@/components/common/LoadingAnimation'
import ViewEntityPermissionsByUser from '@/components/entities/components/ViewEntityPermissionsByUser'
import EventBus from "@/utils/EventBus";

export default {
  components: {
    Searchable,
    Collapsable,
    LoadingAnimation,
    ViewEntityPermissionsByUser
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    },
    limitItems: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      isFetchingServer: true,
      showLoadingIndicator: false,
      querySearch: '',
      entityRoles: []
    }
  },
  created: function () {
    EventBus.$on(`ENTITY_RESPONSIBLE_USERS_UPDATED_${this.entity.id}`, ()=> {
      this.loadEntityRoles()
    })
  },
  methods: {
    loadEntityRoles: function () {
      this.isFetchingServer = true
      RoleService.getRolesByEntity(this.entity.id)
        .then(userRoles => {
          this.entityRoles = userRoles
        })
        .catch(errors => {
          console.log(errors)
          this.showToast(this.$t('roles.something_went_wrong'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          setTimeout(() => {
            this.isFetchingServer = false
          }, 300)
        })
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    userHasRoles: function () {
      return this.$auth.user().services.some(service => service.user_roles.length > 0)
    },
    limitItemsByScreenSize: function () {
      if (this.windowWidth < 768) {
        return 1
      } else if (this.windowWidth < 1024) {
        return 4
      } else if (this.windowWidth < 1280) {
        return 5
      } else {
        return 6
      }
    }
  },
  watch: {
    entity: {
      handler: function (value) {
        this.loadEntityRoles()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 250ms }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 250ms }
.v-enter-to { opacity: 1; }

@keyframes dissapearAnimation {
  0% {
    width: 225px;
  }
  100% {
    width: 0px;
    display: none;
  }
}

.animated {
  animation: spin 500ms infinite;
}

@keyframes spin {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(180deg);}
}
</style>
